import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  CreateOptimizedTerritoriesModalContainer, type CreateOptimizedTerritoriesModalProps,
} from './createOptimizedTerritoriesModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    CreateOptimizedTerritories: CreateOptimizedTerritoriesModalProps;
  }
}
modalRenderer.register('CreateOptimizedTerritories', CreateOptimizedTerritoriesModalContainer);
